var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketLaunch5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6222 8.49463C18.1176 6.99922 18.9729 4.98619 18.9999 2.89838C19.0064 2.39576 18.6042 1.99358 18.1016 2.00008C16.0138 2.02709 14.0008 2.88237 12.5054 4.37778L9.29583 7.58732L7.82048 7.11273C7.29292 6.94303 6.70701 7.08851 6.30699 7.48853L5.11138 8.68414C4.96554 8.82998 4.96253 9.06342 5.10466 9.20552L11.7945 15.8953C11.9366 16.0375 12.17 16.0345 12.3159 15.8886L13.5115 14.693C13.9115 14.293 14.057 13.7071 13.8873 13.1795L13.4127 11.7042L16.6222 8.49463Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.99996C3 8.01749 3.70841 7.20048 4.64229 7.03186L4.05071 7.62344C3.34512 8.32904 3.29051 9.5127 4.04413 10.2663L10.7338 16.956C11.4874 17.7096 12.6709 17.6548 13.3765 16.9492L14.5721 15.7536C15.3594 14.9664 15.6616 13.7971 15.3152 12.7201L15.1212 12.117L17.6829 9.55525C18.4201 8.81806 19.0267 7.97359 19.4857 7.05935C20.3556 7.27637 21 8.06291 21 8.99996V18C21 19.1045 20.1046 20 19 20H5C3.89543 20 3 19.1045 3 18V8.99996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunch5);
export default __webpack_public_path__ + "static/media/rocket-launch-5.91de21507492b60cf523a7f788e22a10.svg";
export { ForwardRef as ReactComponent };